/* global BMS*/
import {
    CHANGE_BET_SLIP_MODAL_SELECTED_SCREEN,
    CREATE_GAMES,
    ENABLE_DISABLE_GAME,
    HANDLE_GET_STATE_RESPONSE,
    OPEN_CLOSE_BET_SLIP_MODAL,
    SELECT_GAME,
    SET_EVENTS,
    SET_NO_MORE_BETS_EVENT
} from './constants/actionTypes';
import {BET_LIMITS} from './constants/betLimits';
import {
    DECREMENT_BET_VALUE,
    INCREMENT_BET_VALUE,
    OPEN_CLOSE_BET_HISTORY,
    REMOVE_ALL_BETS,
    REMOVE_OPEN_BET,
    UNDO_LAST_BET_ACTION
} from './ui-modules/simplified/constants/actionTypes';
import {ADD_OPEN_BET} from './ui-modules/sports-book/constants/actionTypes';
import {
    getNextEventsLastResultsAndNextEventsTime,
    getNextEventsListAndLastResults
} from './communications/platformMessageRequests';

import {
    ALERT_NOTIFICATION,
    ENABLED,
    INFO_NOTIFICATION,
    NMB,
    PLACED_BETS,
    PRE,
    SETTLED_BETS,
    VID,
    WARNING_NOTIFICATION
} from './constants/identifiers';
import {OPERATOR} from './constants/operator';
import {updateSportsBookLocalBetsReadStatus} from './ui-modules/sports-book/helpers/betHelpers';
import {addSimplifiedLocalStoredBets} from './ui-modules/simplified/actions/openBetsActions';
import {clearEventOpenBets, setNoMoreBetsEvent} from './actions/eventsActions';
import {showPlatformNotification} from './actions/modalActions';
import {compareBetRacers} from './ui-modules/simplified/helpers/betHelpers';
import {getFormattedCurrency, getText} from './helpers/localization';
import {updateLocalBetsReadStatus} from "./ui-modules/simplified/helpers/betHistoryHelpers";
import {addSportsBookLocalStoredBets} from "./ui-modules/sports-book/actions/openBetsActions";
import {updatePlayerBalance} from './actions/platformActions';
import {openCloseBetSlipModal} from './ui-modules/sports-book/actions/betSlipActions';
import {MATCHDAY_MODULE_TYPE} from './ui-modules/sports-book/modules/matchday/constants/identifiers';
import {groupMatchdayEvents} from "./helpers/eventHelpers";

export default function Middleware({getState, dispatch}) {
    return next => action => {
        // even though, when SET_NO_MORE_BETS_EVENT action is fired, only the NMB for the currently selected game are written on the
        // store, this action is still fired for every NMB received from VC2 thus, we can assume that NMB message is the trigger
        // point for bet placement for the selected and the unselected games
        let selectedGame;
        switch (action.type) {
            case SET_NO_MORE_BETS_EVENT:
                if (OPERATOR.clientType === 'Simplified' || OPERATOR.clientType === 'SportsBook') {
                    // only clear if bets are present because set no more bets event can be triggered on app start and,
                    // in that case, local storage bets cannot be cleared
                    let eventOpenBets = getState().vpp.openBetsList.filter((openBet) => openBet.bets[0].game.channel === action.nmbEvent.gameChannel && openBet.bets[0].event.eventId === action.nmbEvent.eventId) || [];
                    if (eventOpenBets.length > 0)
                        dispatch(clearEventOpenBets(action.nmbEvent.gameChannel, action.nmbEvent.eventId));
                }
                break;
            case ADD_OPEN_BET: // sports-book
            case INCREMENT_BET_VALUE: // simplified
                let currentbet;
                if (OPERATOR.clientType === 'Simplified') {
                    let existingBet = getState().vpp.openBetsList.find(
                        (openBet) => openBet.game.channel === action.bet.game.channel && openBet.event.eventId === action.bet.event.eventId && openBet.market.id === action.bet.market.id && compareBetRacers(openBet.racers, action.bet.racers)
                    );

                    if (existingBet) {
                        currentbet = existingBet;
                    } else {
                        currentbet = action.bet;
                    }
                    action = _showPlatformNotification(action, dispatch);
                } else {
                    currentbet = action.bet;
                }
                let potentialWinnings = (currentbet.stake + action.value) * Number(currentbet.market.odds);

                if (BET_LIMITS.maxWinnings !== undefined && potentialWinnings && potentialWinnings > BET_LIMITS.maxWinnings) {
                    let maxWinningString = getFormattedCurrency(
                        undefined,
                        BET_LIMITS.maxWinnings / 100,
                        0,
                        getState().vpp.systemLanguage,
                        getState().vpp.systemCurrency,
                    );
                    let maxBetValue = getFormattedCurrency(
                        undefined,
                        BET_LIMITS.maxWinnings / action.bet.market.odds / 100,
                        2,
                        getState().vpp.systemLanguage,
                        getState().vpp.systemCurrency
                    );

                    let notificationTitle = getText('MAX_WINNINGS_REACHED', undefined, undefined, getState().vpp.systemLanguage);
                    let notificationText = getText('MAX_WINNINGS_REACHED_TEXT', undefined, [
                        maxWinningString, maxBetValue
                    ], getState().vpp.systemLanguage);

                    window.GAME.notifyPlayer(WARNING_NOTIFICATION, notificationTitle, notificationText, false);
                    action.type = 'IGNORE';
                }
                break;
            case DECREMENT_BET_VALUE:
            case UNDO_LAST_BET_ACTION:
            case REMOVE_OPEN_BET:
            case REMOVE_ALL_BETS:
            case OPEN_CLOSE_BET_HISTORY:
            case OPEN_CLOSE_BET_SLIP_MODAL:
                break;
            case HANDLE_GET_STATE_RESPONSE:
                /*
                state changed event and place bets successfull response will dispatch HANDLE_GET_STATE_RESPONSE but,
                only the first one is supposed to add local bets to the open bets list...
                */
                if (!action.isPlaceBetResponse) {
                    if (OPERATOR.clientType === 'SportsBook') {
                        dispatch(addSportsBookLocalStoredBets(action.playerUID, getState().vpp.noMoreBetsEventList));
                    } else if (OPERATOR.clientType === 'Simplified') {
                        dispatch(addSimplifiedLocalStoredBets(action.playerUID, getState().vpp.noMoreBetsEventList));
                    }
                }
                updateLocalBetsReadStatus(undefined, getState().vpp.selectedBetHistoryGame, getState().vpp);
                dispatch(updatePlayerBalance(action.Balance, action.playerUID));
                break;
            case ENABLE_DISABLE_GAME:
                if (action.newGameState !== ENABLED) {
                    if (OPERATOR.clientType === 'Simplified') {
                        let gameName = '';

                        if (getState().vpp && getState().vpp.games.length > 0) {
                            let game = getState().vpp.games[action.gameIndex];
                            gameName = game.name;
                        }

                        dispatch(showPlatformNotification(ALERT_NOTIFICATION, ALERT_NOTIFICATION, 'GAME_DISABLED_MESSAGE', true, [gameName]));
                    }
                }
                break;
            case SET_EVENTS:
                if (action.nextEvents !== undefined && action.nextEvents.length > 0) {
                    let isResultShowing = getState().vpp.games.slice().filter((game) => game.channel === action.nextEvents[0].channel && game.isResultShowing === true);
                    if (isResultShowing === undefined || isResultShowing.length === 0) {
                        let isMatchdayChannel = getState().vpp.games[getState().vpp.selectedGameIndex].type == MATCHDAY_MODULE_TYPE;
                        if (isMatchdayChannel) {
                            let matchdayEvents = [];
                            action.nextEvents.forEach(mdevents => mdevents.forEach(evt => matchdayEvents.push(evt)));
                            action.nextEvents = matchdayEvents.slice();
                        }
                        selectedGame = getState().vpp.games[getState().vpp.selectedGameIndex];
                        let currentServerTime = Date.now() - getState().vpp.serverTimeOffset;
                        // OPERATOR.noMoreBetsinMs * 2 serves the purpose of not removing the events that are near its video time and receive a PRE message  [PROD_VSB-1304]
                        if (selectedGame.controllerState === PRE || (selectedGame.controllerState !== undefined && selectedGame.controllerState[1] !== undefined && selectedGame.controllerState[1] === PRE)) {
                            // action.nextEvents = action.nextEvents.slice(1, action.nextEvents.length);
                            action.nextEvents = action.nextEvents.slice().filter((evt) => (evt.eventTimeDate + OPERATOR.noMoreBetsinMs * 2) > currentServerTime);
                        } else if (selectedGame.controllerState === NMB || (selectedGame.controllerState !== undefined && selectedGame.controllerState[1] !== undefined && selectedGame.controllerState[1] === NMB)) {
                            action.nextEvents = action.nextEvents.slice().filter((evt) => (evt.eventTimeDate + OPERATOR.noMoreBetsinMs * 2) > currentServerTime);
                        } else if (selectedGame.controllerState === VID || (selectedGame.controllerState !== undefined && selectedGame.controllerState[1] !== undefined && selectedGame.controllerState[1] === VID)) {
                            action.nextEvents = action.nextEvents.slice().filter((evt) => evt.eventTimeDate >= selectedGame.liveEventTimeDate.$date);
                        }
                        // the time specified to NMB must be injected in BMS.operatorConfig.noMoreBetsinMs
                        if (action.nextEvents !== undefined && action.nextEvents.length) {
                            if (currentServerTime > action.nextEvents[0].eventTimeDate - OPERATOR.noMoreBetsinMs) {
                                // we need to add the event to nmb event list, reducer does not add it if it is already there
                                if (isMatchdayChannel) {
                                    for (let k = 0; k < 8; k++) {
                                        dispatch(setNoMoreBetsEvent(action.nextEvents[k].eventId, action.nextEvents[k].channel, false));
                                    }
                                } else {
                                    dispatch(setNoMoreBetsEvent(action.nextEvents[0].eventId, action.nextEvents[0].channel, false));
                                }
                            }
                        }
                        if (isMatchdayChannel) {
                            action.nextEvents = groupMatchdayEvents(action.nextEvents);
                        }
                    }
                }
                break;
            case CREATE_GAMES:
                // get next events list and last results info
                if (action.gameList !== undefined && action.gameList.length > 0) {
                    getNextEventsLastResultsAndNextEventsTime(action.gameList[getState().vpp.selectedGameIndex].channel, action.gameList[getState().vpp.selectedGameIndex].type, dispatch);
                }
                break;
            case SELECT_GAME:
                // get events on game change unless game state is in PRE
                // events for games in PRE state are fetched on SET_GAME_STATE middleware
                if (action.gameIndex !== getState().vpp.selectedGameIndex /*&& getState().vpp.games[action.gameIndex].controllerState !== PRE*/) {
                    getNextEventsListAndLastResults(getState().vpp.games[action.gameIndex].channel, getState().vpp.games[action.gameIndex].type, dispatch);
                } else if (!getState().vpp.isBetSlipSideView && getState().vpp.isBetSlipModalOpen) {
                    dispatch(openCloseBetSlipModal());
                }
                getState().vpp.matchday.selectedMatchdayEventId = undefined;
                break;
            case CHANGE_BET_SLIP_MODAL_SELECTED_SCREEN:
                if (action.option === PLACED_BETS || action.option === SETTLED_BETS) {
                    updateSportsBookLocalBetsReadStatus(action.option, getState().vpp.playerUID);
                }
                break;
            default:
                break;
        }

        let result = next(action);
        return result;
    };
}

function _showPlatformNotification(action, dispatch) {
    if (process.env.NODE_ENV !== 'development') {
        if (BMS && BMS.authentication && !BMS.authentication.isPlayerLogged) {
            dispatch(showPlatformNotification(INFO_NOTIFICATION, INFO_NOTIFICATION, 'AUTHENTICATION_REQUIRED', true));
            action.type = 'IGNORE';
        }
    }
    return action;
}



// WEBPACK FOOTER //
// ./src/middleware.js